import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import MakeScene from '../scenes/MakeScene';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class GameMenu extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {MakeScene} scene 
     */
    constructor(scene)
    {
        super(scene);

        this.delegate = scene;

        this.btnMenu = ABCyaPhaser.Images.addImage(70, 0, UIAssetKeys._game_assets_BUTTON_menu, this).setOrigin(0).setInteractive();
        this.btnDone = this.scene.add.container(0,0);
        this.add(this.btnDone);
        const btnDoneBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._game_assets_BUTTON_done, this.btnDone);
        this.btnDone.setSize(btnDoneBg.width, btnDoneBg.height).setInteractive();
        const btnDoneTxt = ABCyaPhaser.Text.addText(0,0,34, 0xffffff, FontKeys._bpreplaybold, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.done_button"), this.btnDone, true).setLineSpacing(-5);
        this.btnDone.x = this.scene.scale.width - (this.btnDone.width/2) - 46;
        this.btnDone.y = (this.btnDone.height/2) + 30;

        this.btnMenu.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClickMenu, this);
        this.btnDone.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClickDone, this);

        this.overlay = this.scene.add.container(0,0,this.scene.add.rectangle(0,0, this.scene.scale.width, this.scene.scale.height, 0x000000, 0.8).setOrigin(0).setInteractive()).setVisible(false);
        this.buttonStrip = ABCyaPhaser.Images.addImage(0, this.scene.scale.height/2, UIAssetKeys._game_assets_MenuStrip, this.overlay).setOrigin(0);
        
        const menuButtonTextYPosition = ABCyaLib.Environment.instance.gameConfig.menuButtonTextYPosition;

        this.btnResume = this.scene.add.container(this.scene.scale.width*0.33,this.buttonStrip.y+(this.buttonStrip.height/2));
        this.overlay.add(this.btnResume);
        const btnResumeBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._game_assets_BTN_0,this.btnResume);
        const btnResumeTxt = ABCyaPhaser.Text.addText(0,menuButtonTextYPosition,18, 0xffffff, FontKeys._bpreplayregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.menu_popup.resume_button"), this.btnResume, true).setResolution(1.5);
        this.btnResume.setSize(btnResumeBg.width, btnResumeBg.height).setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.closeMenu, this);

        this.btnStartOver = this.scene.add.container(this.scene.scale.width*0.66, this.buttonStrip.y+(this.buttonStrip.height/2));
        this.overlay.add(this.btnStartOver);
        const btnStartOverBg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._game_assets_BTN_1,this.btnStartOver);
        const btnStartOverTxt = ABCyaPhaser.Text.addText(0,menuButtonTextYPosition,18, 0xffffff, FontKeys._bpreplayregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.menu_popup.start_over_button"), this.btnStartOver, true).setResolution(1.5).setLineSpacing(-5);
        this.btnStartOver.setSize(btnStartOverBg.width, btnStartOverBg.height).setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.startOver, this);
        
        this.add(this.overlay);
    }

    onClickMenu() {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._button_click, this.scene);

        this.overlay.setVisible(true);
    }

    closeMenu() {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._button_click, this.scene);
        this.overlay.setVisible(false);
    }

    startOver(e) {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._button_click, this.scene);
        this.delegate.doStartOver();
        this.closeMenu();
    }

    onClickDone() {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._button_click, this.scene);
        this.btnMenu.removeAllListeners();
        this.btnDone.removeAllListeners();

        this.delegate.allDone();
    }
}